import { render, staticRenderFns } from "./ForceAppUpdatePage.vue?vue&type=template&id=0fba2392"
import script from "./ForceAppUpdatePage.vue?vue&type=script&lang=js"
export * from "./ForceAppUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports